import React from "react";

const LoadingWrapper = ({ isLoading, children }) => {
  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center w-full h-full">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default LoadingWrapper;
